export default class VideoCategoryAdmin {
    id: string;
    normalizedName: string;
    sortOrder: number;
    localizedName: string;

    constructor(json: any) {
        this.id = json.id;
        this.normalizedName = json.normalizedName;
        this.sortOrder = json.sortOrder;
        this.localizedName = json.localizedName;
    }
}
